export default __webpack_public_path__ + "7f9f098dd05694e36e40b37f1e55df96.png";